import { styled, theme } from "../../../../../../styles/stitches.config"
import { Flex } from "../../../../../../components/flex/Flex"
import { Sipo } from "../../../../../../images/xd/icons"
import { DynamicTable } from "./ContractSelectionTable"
import { Product } from "../../form/useAcquisitionFormSchema"
import { Spacer } from "../../../../../../components/spacer/Spacer"

const Icon = styled(Sipo, {
  marginTop: theme.space.s4,
})

type Props = {
  selectedProduct: Product
  productionDataTariff?: boolean
}

export function ProductsPriceDetail(controller: Props) {
  const { selectedProduct, productionDataTariff } = controller

  return (
    <Flex direction="column" align="center" css={{ width: "100%" }}>
      {!selectedProduct && <Icon height={100} width={100} color={theme.colors.lines.value} />}
      {selectedProduct === "consumption" && (
        <DynamicTable
          rowData={[
            {
              name: "Odběr",
              value: "SPOT + 350",
              unit: "Kč/MWh",
            },
          ]}
        />
      )}
      {selectedProduct === "productionAndConsumption" && (
        <DynamicTable
          rowData={[
            {
              name: "Odběr",
              value: "SPOT + 350",
              unit: "Kč/MWh",
            },
            {
              name: "Prodej",
              value: productionDataTariff ? "SPOT - 450" : "SPOT - 600",
              unit: "Kč/MWh",
              tariff: productionDataTariff,
            },
          ]}
        />
      )}
      {selectedProduct === "production" && (
        <>
          <DynamicTable
            rowData={[
              {
                name: "Prodej",
                value: productionDataTariff ? "SPOT - 450" : "SPOT - 600",
                unit: "Kč/MWh",
                tariff: productionDataTariff,
              },
            ]}
          />
          <Spacer size={theme.space.s10} css={{ display: "none", "@md": { display: "block" } }} />
        </>
      )}
    </Flex>
  )
}
